export function normalizeTwoFactorSkipPolicy(source) {
  if (!source || source.allow_2fa_skip_configuration !== true) {
    return null;
  }

  const allowedDays = Array.isArray(source.allowed_2fa_skip_days)
    ? [...new Set(source.allowed_2fa_skip_days.map((day) => Number(day)))].sort((a, b) => a - b)
    : [];

  if (allowedDays.length === 0) {
    return null;
  }

  return {
    allow_2fa_skip_configuration: true,
    allowed_2fa_skip_days: allowedDays,
  };
}

export function pickTwoFactorSkipPolicy(source) {
  if (!source) {
    return null;
  }

  return normalizeTwoFactorSkipPolicy({
    allow_2fa_skip_configuration: source.allow_2fa_skip_configuration,
    allowed_2fa_skip_days: source.allowed_2fa_skip_days,
  });
}

export function shouldShowRememberBrowserSelect(policy) {
  const normalized = normalizeTwoFactorSkipPolicy(policy);
  if (!normalized) {
    return false;
  }

  return normalized.allowed_2fa_skip_days.some((day) => day > 0);
}

export function buildRememberBrowserOptions(policy, t) {
  const normalized = normalizeTwoFactorSkipPolicy(policy);
  if (!normalized) {
    return [];
  }

  const positiveDays = normalized.allowed_2fa_skip_days.filter((day) => day > 0);
  if (positiveDays.length === 0) {
    return [];
  }

  const options = [
    {
      value: 'none',
      label: t('auth.login.two-factor-remember-option-none'),
    },
  ];

  positiveDays.forEach((days) => {
    options.push({
      value: String(days),
      label: t('auth.login.two-factor-remember-option-days', { days }),
    });
  });

  return options;
}

export function buildTwoFactorChallengeFromResponse(data, base) {
  return {
    ...base,
    maskedEmail: data.masked_email,
    codeExpiresAt: data.code_expires_at,
    challengeToken: data.two_factor_challenge_token,
    twoFactorSkipPolicy: pickTwoFactorSkipPolicy(data),
  };
}

export function mergeTwoFactorChallengeState(previous, responseData) {
  if (!previous) {
    return previous;
  }

  return {
    ...previous,
    maskedEmail: responseData.masked_email ?? previous.maskedEmail,
    codeExpiresAt: responseData.code_expires_at ?? previous.codeExpiresAt,
    challengeToken: responseData.two_factor_challenge_token ?? previous.challengeToken,
    twoFactorSkipPolicy: pickTwoFactorSkipPolicy(responseData) ?? previous.twoFactorSkipPolicy,
  };
}
